exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goal-bg{\n    background-color:#e6e6e6 ;\n    margin:7px;\n}\n\n.add-goal{\n    margin-right: 25px\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/template-metrics/create-template-metrics/create-template-metrics.component.css
// module id = ../../../../../src/app/template-metrics/create-template-metrics/create-template-metrics.component.css
// module chunks = main